import { IS_ADMIN } from './validation';

export const ROLES = {
  ADMIN: IS_ADMIN ? 'SUPER_ADMIN' : 'ADMIN',
  RESELLER_ADMIN: 'RESELLER_ADMIN',
  SUPPORT: 'SUPPORT',
  SERVICE_MANAGER: 'SERVICE_MANAGER',
  VIEW_ONLY_FM: 'VIEWONLY_FLMANAGER',
  SUPER_ADMIN: 'SUPER_ADMIN',
  UNDER_WRITER: 'UNDER_WRITER',
  LOSS_CONTROL: 'LOSS_CONTROL',
  CLAIM_ADJUSTER: 'CLAIM_ADJUSTER',
  FLMANAGER: 'FLMANAGER',
  DRIVER: 'DRIVER',
  OWNER: 'OWNER',
  MECHANIC: 'MECHANIC',
};
